import { Document, Page, type PageProps } from '@react-pdf/renderer';
import type { ReactElement } from 'react';

import type { Quote } from '@core/types/api/Quote/Quote';

import { PdfSignatures } from '../../../default/components/PdfSignatures';

const pageStyle: PageProps['style'] = {
  padding: '0.5in',
};

type CarewDefaultSigningSectionProps = {
  quote: Quote;
  // locale is passed from TemplateByName but not used in this signing section
  // eslint-disable-next-line react/no-unused-prop-types
  locale: string;
};

export const CarewDefaultSigningSection = ({
  quote,
}: CarewDefaultSigningSectionProps): ReactElement => (
  <Document title={quote.quoteNumber}>
    <Page style={pageStyle}>
      <PdfSignatures quote={quote} tenantName='Carew Concrete' />
    </Page>
  </Document>
);
